import React, { useEffect, useState } from "react";
import { utils, writeFile } from "xlsx";
import styled from "styled-components";
import LineBtn from "../Button/LineBtn";
import { useApi } from "../../hooks/useApi";
import { useRecoilValue } from "recoil";
import { authType } from "../../pages/Login";
import dayjs from "dayjs";
import Loader from "./Loader";
import { toast } from "react-toastify";

interface ExcelDownloadProps {
  tableHead?: any[];
  pushedData?: (e: any) => any[];
  dataUrl?: string;
  disabled?: boolean;
  title?: string;
  cellMerge?: () => void;
}

export default function ExcelDownload({
  tableHead,
  pushedData,
  dataUrl,
  disabled,
  title,
  cellMerge,
}: ExcelDownloadProps) {
  const auth = useRecoilValue(authType);

  const [click, setClick] = useState(false);

  const {
    response: excelResponse,
    loading,
    error,
  } = useApi({
    method: "get",
    url: click && dataUrl ? `${dataUrl}` : undefined,
  });

  useEffect(() => {
    if (excelResponse?.status === 200 && click && dataUrl) {
      const getDataByAoa = () => {
        let arr: any[] = [tableHead?.slice(0, -1)];

        for (let i = 0; i < excelResponse?.data?.items.length; i++) {
          const e = excelResponse?.data?.items[i];
          arr.push(pushedData ? pushedData(e) : []);
        }

        return arr;
      };

      const book = utils.book_new();
      // data get > 실 개발시 api 호출
      const data = getDataByAoa();

      // sheet 생성 - aoa_to_sheet 방식
      const worksheetByAoa = utils.aoa_to_sheet(data);

      if (cellMerge) {
        cellMerge();

        var merge = { s: { r: 0, c: 0 }, e: { r: 0, c: 1 } };

        if (!worksheetByAoa["!merges"]) worksheetByAoa["!merges"] = [];
        worksheetByAoa["!merges"].push(merge);
      }

      // 엑셀 파일에 sheet set(엑셀파일, 시트데이터, 시트명)
      utils.book_append_sheet(book, worksheetByAoa, "admin");

      // 엑셀 다운로드
      writeFile(
        book,
        `admin_${title}_${dayjs().format("YYYY-MM-DD HH:mm:ss")}.xlsx`
      );
    }
  }, [excelResponse, pushedData, tableHead, title]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "데이터를 불러오는 데 실패하였습니다.");
    }
  }, [error]);

  if (loading && click) {
    return <Loader />;
  }

  return (
    <ExcelDownBtnContainer>
      <LineBtn
        btnText="엑셀 다운로드"
        icon="download"
        disabled={disabled || !auth?.excelDownload}
        btnClickEvent={() => {
          if (click) return;

          setClick(true);

          setTimeout(() => {
            setClick(false);
          }, 2000);
        }}
      />
    </ExcelDownBtnContainer>
  );
}

const ExcelDownBtnContainer = styled.div`
  margin-top: 10px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;
